import initTags from '../middleware/yandex/yandex.init';

(async function () {
  await initTags();
}());
